export default "__VITE_ASSET__DzTVR2eC__"